import './PropMgmt.css';

function PropMgmt() {
    return (
      <>
      </>
    );
  }
  
  export default PropMgmt;